<template>
  <div class="event-detail">
    <div v-if="loaded && workshop">
      <o-card :title="''">
        <div class="card-header px-0 pt-0 pb-3 row">
          <div class="col text-left">
            <img src="/images/back.svg"/>
            <o-button class="back-text" variant="link" @click.prevent="back">
              <span>{{ $t('core.back') }}</span>
            </o-button>
          </div>
        </div>
        <div v-if="workshop" class="upcoming-events">
          <b class="workshop-title">{{ workshop.title }}</b>

          <div class="row">
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-calendar"><img src="/images/calendar.svg"/></div>
                <div class="calendar-text">
                  {{ workshop.date|formatDay }} {{ workshop.date|formatDate }},
                  <br class="d-block d-sm-none">
                  {{ workshop.time|formatTimeString }}-{{ workshop.end_time|formatTimeString }}
                  <template v-if="workshop.with_apero"><br> {{ $t("medtastic.apero_text")}}  </template>
                </div>
              </div>
            </div>
            <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/location.svg"/></div>
                <div class="location-text"><span v-html="workshop.location"></span>, {{ workshop.region }}</div>
              </div>
            </div>
            <div class="col-12" v-if="workshop.credits" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
              <div class="mt-4 d-flex">
                <div class="icon-location"><img src="/images/credits.svg"/></div>
                <div class="location-text">{{ workshop.credits }}</div>
              </div>
            </div>
          </div>
        </div>
      </o-card>

      <template v-if="workshop.signup_active">
        <br>

        <o-card id="registration" :title="''" class="mt-2">
          <div class="registration-title">{{ $t('medtastic.registration') }}</div>
          <form class="ortic-form-horizontal" @keydown="form.onKeydown($event)" @submit.prevent="registration">
            <b class="r-form-tile">
              {{ $t('medtastic.personal_information') }}
            </b>
            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <input v-model="form.title" :class="{ 'is-invalid': form.errors.has('title') }"
                       :placeholder="$t('core.title')"
                       class="form-control" name="title" type="text">
                <has-error :form="form" field="title"></has-error>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12 col-sm-6 pl-0 pr-1">
                <input v-model="form.first_name" :class="{ 'is-invalid': form.errors.has('first_name') }"
                       :placeholder="$t('core.first_name') + '*'" class="form-control" name="first_name" type="text">
                <has-error :form="form" field="first_name"></has-error>
              </div>
              <div class="col-sm-6 pl-1 pr-0 d-none d-sm-block">
                <input v-model="form.last_name" :class="{ 'is-invalid': form.errors.has('last_name') }"
                       :placeholder="$t('core.last_name') + '*'" class="form-control" name="last_name" type="text">
                <has-error :form="form" field="last_name"></has-error>
              </div>
            </div>
            <div class="form-group d-block d-sm-none">
              <div class="col-12 pl-0 pr-0">
                <input v-model="form.last_name" :class="{ 'is-invalid': form.errors.has('last_name') }"
                       :placeholder="$t('core.last_name') + '*'" class="form-control" name="last_name" type="text">
                <has-error :form="form" field="last_name"></has-error>
              </div>
            </div>
            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }"
                       :placeholder="$t('core.email') + '*'"
                       class="form-control" name="email" type="text">
                <has-error :form="form" field="email"></has-error>
              </div>
            </div>
            <b class="r-form-tile">
              {{ $t('medtastic.business_address') }}
            </b>
            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <input v-model="form.institution" :class="{ 'is-invalid': form.errors.has('institution') }"
                       :placeholder="$t('medtastic.institution')" class="form-control" name="institution"
                       type="text">
                <has-error :form="form" field="institution"></has-error>
              </div>
            </div>
            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <input v-model="form.institution_address"
                       :class="{ 'is-invalid': form.errors.has('institution_address') }"
                       :placeholder="$t('medtastic.institution_address') + '*'" class="form-control"
                       name="institution_address"
                       type="text">
                <has-error :form="form" field="institution_address"></has-error>
              </div>
            </div>
            <div class="form-group">
              <div class="col-12 col-sm-6 pl-0 pr-1">
                <input v-model="form.postal_code" :class="{ 'is-invalid': form.errors.has('postal_code') }"
                       :placeholder="$t('medtastic.postal_code') + '*'" class="form-control" name="postal_code"
                       type="number">
                <has-error :form="form" field="postal_code"></has-error>
              </div>
              <div class="col-sm-6 pl-1 pr-0 d-none d-sm-block">
                <input v-model="form.city" :class="{ 'is-invalid': form.errors.has('city') }"
                       :placeholder="$t('medtastic.city') + '*'"
                       class="form-control" name="city" type="text">
                <has-error :form="form" field="city"></has-error>
              </div>
            </div>
            <div class="form-group d-block d-sm-none">
              <div class="col-12 pl-0 pr-0">
                <input v-model="form.city" :class="{ 'is-invalid': form.errors.has('city') }"
                       :placeholder="$t('medtastic.city') + '*'"
                       class="form-control" name="city" type="text">
                <has-error :form="form" field="city"></has-error>
              </div>
            </div>
            <b class="r-form-tile">
              {{ $t('core.country') }}*
            </b>
            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <b-form-select v-model="form.country" :class="{ 'is-invalid': form.errors.has('country') }">
                  <b-form-select-option :value="''">{{$t('core.select')}}</b-form-select-option>
                  <b-form-select-option value="switzerland">{{$t('medtastic.switzerland')}}</b-form-select-option>
                  <b-form-select-option value="germany">{{$t('medtastic.germany')}}</b-form-select-option>
                  <b-form-select-option value="austria">{{$t('medtastic.austria')}}</b-form-select-option>
                </b-form-select>
                <has-error :form="form" field="country"></has-error>
              </div>
            </div>
            <b class="r-form-tile">
              {{ $t('medtastic.event_aimed_healthcare') }}
            </b>
            <div class="form-group">
              <div class="col-md-12 pl-0">
                <b-form-checkbox v-model="form.terms_conditions"
                                 :class="{ 'is-invalid': form.errors.has('terms_conditions') }"
                                 class="widelabel">{{ $t('medtastic.agree_to_terms_conditions') }}*
                </b-form-checkbox>
                <has-error :form="form" field="terms_conditions"></has-error>

                <b-modal id="tc-modal" :title="$t('medtastic.terms_conditions')" ok-only size="xl">
                  <div v-if="!workshop.agb" class="pre-formatted" v-html="$t('medtastic.terms_conditions_content')">
                  </div>
                  <div v-else class="pre-formatted">
                    <div v-html="workshop.agb"></div>
                  </div>
                </b-modal>
              </div>
            </div>

            <b class="r-form-tile">
              {{ $t('medtastic.user_type') }}*
            </b>

            <div class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <b-form-select v-model="form.user_type" :class="{ 'is-invalid': form.errors.has('user_type') }">
                  <b-form-select-option :value="''">{{$t('core.select')}}</b-form-select-option>
                  <b-form-select-option value="Gastroenterologist">
                    {{$t('medtastic.gastroenterologist')}}
                  </b-form-select-option>
                  <b-form-select-option value="IBD_Nurse">
                    {{$t('medtastic.ibd_nurse')}}
                  </b-form-select-option>
                  <b-form-select-option value="MPA">{{$t('medtastic.mpa')}}</b-form-select-option>
                  <b-form-select-option value="Other">{{$t('medtastic.other_specify')}}</b-form-select-option>
                </b-form-select>
                <has-error :form="form" field="user_type"></has-error>
              </div>
            </div>

            <div v-if="form.user_type === 'Other'" class="form-group">
              <div class="col-md-12 pl-0 pr-0">
                <input v-model="form.user_type_other" :class="{ 'is-invalid': form.errors.has('user_type_other') }"
                       :placeholder="$t('medtastic.user_type_other') + '*'"
                       class="form-control" name="city" type="text">
                <has-error :form="form" field="user_type_other"></has-error>
              </div>
            </div>

            <b class="r-form-tile">
              {{ $t('medtastic.participate') }}
            </b>
            <div class="form-group">
              <div class="col-md-12 pl-0">
                <b-form-checkbox v-model="form.case_discussion" name="case_discussion"
                                 :class="{ 'is-invalid': form.errors.has('case_discussion') }"
                                 class="widelabel">{{ $t('medtastic.case_discussion') }}
                </b-form-checkbox>
              </div>
            </div>

            <template v-if="workshop.event_type == 'Hybrid'">
              <b class="r-form-tile">
                {{ $t('medtastic.participation') }}
              </b>
              <div class="form-group">
                <div class="col-md-12 pl-0">
                  <b-form-group :label="''" v-slot="{ ariaDescribedby }">
                    <b-form-radio v-model="form.participation_type" :aria-describedby="ariaDescribedby" name="participation-type" value="Virtual">
                      {{ $t('medtastic.virtual') }}
                    </b-form-radio>
                    <b-form-radio v-model="form.participation_type" :aria-describedby="ariaDescribedby" name="participation-type" value="On-Site">
                      {{ $t('medtastic.on_site') }}
                    </b-form-radio>
                    <has-error :form="form" field="participation_type"></has-error>

                  </b-form-group>
                </div>
              </div>
            </template>
            <input v-else type="hidden" v-model="form.participation_type">

            <template v-if="workshop.sponsors && workshop.sponsors.data && Object.keys(workshop.sponsors.data).length">
              <template v-for="(sponsor, i) in workshop.sponsors.data">
                <template v-if="sponsor.sponsor.data && sponsor.sponsor.data.sponsor_checkboxes && sponsor.sponsor.data.sponsor_checkboxes.data && Object.keys(sponsor.sponsor.data.sponsor_checkboxes.data).length">
                  <b class="r-form-tile">
                    {{ sponsor.sponsor.data.name }}
                  </b>
                  <template v-for="checkbox in sponsor.sponsor.data.sponsor_checkboxes.data">
                    <div class="form-group" v-if="workshop.sponsor_checkbox_array.includes(checkbox.id)">
                      <div class="col-md-12 pl-0 pr-0">
                        <b-form-checkbox v-model="form.checkboxes"
                                         :name="sponsor.sponsor.data.name + '_' + checkbox.id"
                                         :value="checkbox.id" class="long-checkbox">
                          <span v-html="checkbox['label_' + locale]"/>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </template>

            <div class="form-group mt-5 mb-5">
              <div class="col-md-12 pl-0 pr-0 text-left btn-registration">
                <o-button :loading="form.busy" variant="dark">
                  {{ $t('medtastic.submit_register') }}
                </o-button>
              </div>
            </div>
            <br>
          </form>
        </o-card>
      </template>
    </div>
    <div v-if="loaded && !workshop">
      <o-card :shadow="false" :title="$t('core.page_not_found')" class="col-lg-8">
        <router-link class="btn btn-primary" to="/">
          {{ $t('medtastic.back_to_home') }}
        </router-link>
      </o-card>
    </div>
    <div v-if="!loaded">
      <div class="btn-loading">&nbsp;<br>&nbsp;<br>&nbsp;</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  layout: 'user',
  data () {
    return {
      loaded: false,
      workshop: null,
      workshop_locale: window.config.workshop_locale,
      form: new Form({
        workshop_id: null,
        title: '',
        first_name: '',
        last_name: '',
        institution: '',
        institution_address: '',
        country: '',
        city: '',
        postal_code: '',
        email: '',
        confirm_email: '',
        language: window.config.workshop_locale,
        terms_conditions: false,
        user_type: '',
        user_type_other: '',
        checkboxes: [],
        case_discussion: false,
        participation_type: null
      }),
      registered: false,
      sponsorTitleExists: []
    }
  },
  mounted () {
    this.workshopDetail()
  },
  computed: mapGetters({
    locale: 'lang/locale'
  }),
  methods: {
    workshopDetail: function () {
      axios.get('/api/medtastic/workshops/public?include=sponsor_checkboxes,sponsors.sponsor.sponsor_checkboxes&filter%5Bid%5D=' + this.$route.params.id)
          .then((response) => {
            this.workshop = response.data.data[0]
            this.form.workshop_id = this.workshop.id
            if(this.workshop.event_type !== 'Hybrid') {
               this.form.participation_type = this.workshop.event_type
            }
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
            this.loaded = true
          })
    },
    async registration () {
      this.form.language = this.locale
      await this.form.post('/api/medtastic/workshop_registrations/register')

      this.$router.push({ name: 'medtastic.event_thanks' })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>
